export default __webpack_public_path__ + "static/media/cart-desktop.af42ecf5.png";